import React from 'react';
import { useNavigate } from 'react-router';

import styled from '@emotion/styled';

import { FormSubmitButton } from '../../../components/Button/FormSubmitButton';
import { FormComponent } from '../../../components/FormCom/FormComponent';
import { TextInputField } from '../../../components/FormCom/FormField';
import { HideableTextFormField } from '../../../components/FormCom/HideableTextFormField';
import useSignin from '../../../hooks/auth/admin/useSignin';
import {
  SignInDataType,
  signinInitialValues,
  SignInSchema,
} from '../../../models/auth/signIn.model';

const SignIn = () => {
  const navigate = useNavigate();
  const { loading, signin, signInError } = useSignin();

  const onSubmit = (value: SignInDataType) => {
    signin(value);
  };

  const onForgotPassword = () => {
    navigate('/account/forgot-password');
  };

  return (
    <Container>
      <FormWrapper>
        <FormHeader>
          <div className='title'>Login to your LogiRate Admin account</div>
          <div className='description'>
            Log in to your registered Logi Rate account
          </div>
        </FormHeader>

        <FormComponent
          initialValues={signinInitialValues}
          schema={SignInSchema}
          onSubmit={onSubmit}
        >
          <TextInputField
            label='Email'
            name='email'
            id='email'
            type='email'
            placeholder='Email'
          />
          <HideableTextFormField
            label='Password'
            name='password'
            type='password'
            id='password'
            placeholder='Password'
          />
          <ForgotPasswordText onClick={onForgotPassword}>
            Forgot password?
          </ForgotPasswordText>{' '}
          {signInError && <InvalidOTP>{signInError}</InvalidOTP>}
          <FormSubmitButton className='large' loading={loading}>
            Submit
          </FormSubmitButton>
        </FormComponent>
      </FormWrapper>
    </Container>
  );
};

export default SignIn;

const Container = styled.div`
  display: flex;
  height: 100vh;
  color: ${({ theme }) => theme.palette.grayTextColor};
  background-color: ${({ theme }) => theme.palette.lightSignInBg};
`;

const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 400px;
  align-self: center;
  gap: 24px;
  margin: auto;
`;

const FormHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 4px;

  & > .title {
    font-weight: 600;
    font-size: 20px;
    line-height: 27px;
    color: ${({ theme }) => theme.palette.logirateBlack};
  }

  & > .description {
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
  }
`;

const InvalidOTP = styled.div`
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  padding: 16px 108px;
  background-color: ${({ theme }) => theme.palette.warningBgColor};
  color: ${({ theme }) => theme.palette.warningTextColor};
  border-radius: 8px;
  font-weight: 500;
  line-height: 16px;
  font-size: 16px;
  margin-top: -16px;
`;

const ForgotPasswordText = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme }) => theme.palette.blueColor};
  cursor: pointer;
  align-self: flex-end;
  margin-top: -20px;
  width: fit-content;

  @media (max-width: 884px) {
    text-align: right;
    margin-left: auto;
  }
`;
